import { FC, PropsWithChildren } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { HTMLAttributes, useMemo } from 'react';
import { cn } from '../../../utils/helpers';

const cell = cva(['pl-4 pr-[11px] py-4', 'text-sm', 'max-w-[430px] truncate'], {
  variants: {
    type: {
      icon: ['flex', 'gap-3', 'items-center', 'font-semibold'],
      email: [],
      avatar: [],
    },
    size: {
      sm: [],
      md: [],
    },
  },
  compoundVariants: [
    {
      type: 'icon',
      size: 'sm',
      className: ['py-[17px]'],
    },
    {
      type: 'icon',
      size: 'md',
      className: ['py-[29px]'],
    },
    {
      type: 'avatar',
      size: 'sm',
      className: ['py-4'],
    },
    {
      type: 'avatar',
      size: 'md',
      className: ['py-7'],
    },
  ],
});

type PROPS = VariantProps<typeof cell> &
  HTMLAttributes<HTMLDivElement> & {
    data: { [key: string]: any };
  };

interface Props extends PropsWithChildren, PROPS {}

const Cell: FC<Props> = ({ type, data, className, children }) => {
  const { icon: Icon, label } = data;
  const typeMapper = useMemo(() => {
    switch (type) {
      case 'avatar':
        return <></>;
      case 'email':
        return <></>;
      case 'icon':
        return (
          <>
            <Icon className="w-5 h-5" />
            {label}
          </>
        );
      default:
        return data.label;
    }
  }, [Icon, data.label, label, type]);

  if (children) {
    return <>{children}</>;
  }

  return <div className={cn(cell({ type, className }))}>{typeMapper}</div>;
};

export default Cell;
